import { render, staticRenderFns } from "./SentMail.vue?vue&type=template&id=65b8586c&scoped=true"
import script from "./SentMail.vue?vue&type=script&lang=js"
export * from "./SentMail.vue?vue&type=script&lang=js"
import style0 from "./SentMail.vue?vue&type=style&index=0&id=65b8586c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b8586c",
  null
  
)

export default component.exports